define('common/views/download_leads_popup',['require','exports','module','common/views/modal_layout','common/views/datepicker','common/models/date_model','services/auth/info','common/models/appstate','jquery','i18n','ldsh!../templates/download_leads_popup'],function (require, exports, module) {
  'use strict';

  var ModalLayout = require('common/views/modal_layout'),
    Datepicker = require('common/views/datepicker'),
    DateModel = require('common/models/date_model'),
    AuthInfo = require('services/auth/info'),
    authInfo = new AuthInfo(),
    AppState = require('common/models/appstate');

  var $ = require('jquery');
  var i18n = require('i18n');

  module.exports = ModalLayout.extend(
    {
      template: require('ldsh!../templates/download_leads_popup'),

      regions: {
        datepicker: '.js-datepicker',
      },

      events: {
        'click .js-ok': 'startDownload',
      },

      helpers: function () {
        return {
          companies: authInfo.getCompanies(),
        };
      },

      initialize: function (options) {
        module.exports.__super__.initialize.apply(this, arguments);
        AppState.unsetCsvToDownload();
        this.regions.datepicker.show(
          new Datepicker({
            model: new DateModel(),
            className: 'ed-stats-dateFilter',
            titleTranslationKey: 'leadsDownload.datepickerTitle',
            noButton: true,
            noLabel: true,
          })
        );
      },
      _hasDateErrors: function (date) {
        // let's ignore unchangedDate errors as they won't affect us
        return _.reduce(
          date.validationError,
          function (hasError, error) {
            return hasError || error.errorKey !== 'unchangedDate';
          },
          false
        );
      },
      startDownload: function (e) {
        e.preventDefault();
        var datepicker = this.regions.datepicker.currentView,
          date = datepicker.model,
          companyId = authInfo.getCompanyId();

        if (!this._hasDateErrors(date) && companyId) {
          this._hideErrors();
          var info = _.extend(date.toJSON(), { company_id: companyId });
          AppState.setCsvToDownload(info);
          this.hide();
        }
      },

      _hideErrors: function () {
        this.$('.ed-form-group').removeClass('has-error');
      },
      onRender: function () {
        this.$el.i18n();
      },
    },
    {
      show: function (domain) {
        var popup = new module.exports();
        return popup;
      },
    }
  );
});

